import React from 'react';
import { formatSignedAt } from './baaApi';

const Row = ({ label, value, testid }) => (
  <div className="flex gap-2 text-sm py-1 border-b border-slate-100 last:border-0">
    <span className="w-40 shrink-0 text-slate-500">{label}</span>
    <span className="text-slate-900 font-medium break-words min-w-0" data-testid={testid}>{value || '—'}</span>
  </div>
);

export const BusinessAssociateBlock = ({ date }) => (
  <div className="rounded-xl border border-slate-200 bg-slate-50 p-4" data-testid="baa-business-associate-block">
    <p className="text-[11px] font-bold tracking-[0.16em] text-slate-500 uppercase mb-2">Business Associate</p>
    <p className="font-semibold text-slate-900">The OnCall Bot LLC d/b/a PractCom</p>
    <p className="font-[cursive] text-2xl text-[#0b2545] my-1" style={{ fontFamily: '"Dancing Script", "Brush Script MT", cursive' }}>
      The OnCall Bot LLC
    </p>
    <p className="text-sm text-slate-600">By: Authorized Representative, The OnCall Bot LLC</p>
    <p className="text-sm text-slate-600">Date: {date ? formatSignedAt(date) : 'Effective on your acceptance'}</p>
    <p className="text-[11px] text-slate-400 mt-1">Pre-authorized company execution.</p>
  </div>
);

export const SignedRecord = ({ a }) => (
  <div className="space-y-4" data-testid="baa-signed-record">
    <div className="rounded-xl border border-emerald-200 bg-emerald-50/60 p-4">
      <p className="text-[11px] font-bold tracking-[0.16em] text-emerald-700 uppercase mb-2">Covered Entity · Electronic Acceptance Record</p>
      <Row label="Practice / Organization" value={a.practiceName} testid="baa-record-practice" />
      <Row label="Practice address" value={a.practiceAddress} />
      <Row label="Authorized representative" value={a.representativeName} testid="baa-record-rep" />
      <Row label="Title" value={a.title} />
      <Row label="Email" value={a.email} />
      <Row label="PractCom account ID" value={a.practiceId} />
      <Row label="BAA version" value={a.baaVersion} />
      <Row label="Terms version" value={a.termsVersion} />
      <Row label="Effective date & time" value={formatSignedAt(a.signedAt)} testid="baa-record-signed-at" />
      <Row label="IP address" value={a.ip} />
      <Row label="Templates & legal-review notice" value={a.templatesAcknowledged ? 'Acknowledged' : 'Not recorded'} testid="baa-record-templates" />
      <div className="pt-3">
        <p className="text-xs text-slate-500 mb-1">Signature</p>
        {a.signatureType === 'drawn' && a.signatureImage ? (
          <img src={a.signatureImage} alt="Signature" className="h-20 bg-white rounded border" />
        ) : (
          <p className="text-3xl text-[#0b2545]" style={{ fontFamily: '"Dancing Script", "Brush Script MT", cursive' }}>{a.signatureText}</p>
        )}
      </div>
    </div>
    <BusinessAssociateBlock date={a.signedAt} />
  </div>
);
